import axios from "axios";

import Token from "../../utilities/jwt/Token.js";

export default class GroupService extends Token {
  findAll() {
    return axios({
      method: "get",
      url: this.api_url + "group",
      withCredentials: true,
    }).then((res) => res.data);
  }

  create(group) {
    return axios({
      method: "post",
      url: this.api_url + "group",
      withCredentials: true,
      data: group,
    });
  }
  update(group) {
    return axios({
      method: 'put',
      url: this.api_url + 'group/' + group.id,
      withCredentials: true,
      data: group,
    });

  }

  delete(id) {
    return axios({
      method: 'delete',
      url: this.api_url + 'group/' + id,
      withCredentials: true,
    });

  }
}
